export default __webpack_public_path__ + "static/media/placeholder-person-circle.aab5ac52.png";